import { render, staticRenderFns } from "./SubItemShowView.vue?vue&type=template&id=0627e23a&scoped=true&"
import script from "./SubItemShowView.vue?vue&type=script&lang=js&"
export * from "./SubItemShowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0627e23a",
  null
  
)

export default component.exports